import React from 'react';

import styled from 'styled-components';

import Button from 'components/lib/Button';
import { useCommunityViewContext } from 'components/View/CommunityViewContext';
import { CommunityType } from 'types/communities';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
  padding: 15px 0;
`;

const CommunityButton = styled(Button)`
  border-radius: 25px;
  height: 26px;
  font-size: 12px;
  padding: 5px 10.5px;
  font-weight: 500;
`;

type Props = {
  selectedCommunityId: number | null;
  onCommunityChange: (communityId: number | null) => void;
  dataTestId?: string;
  showAllTab?: boolean;
  filteredCompetitors: number[];
};

export const CommunitySwitcher = ({
  selectedCommunityId,
  onCommunityChange,
  dataTestId = '',
  showAllTab = true,
  filteredCompetitors = [],
}: Props) => {
  const { community } = useCommunityViewContext();

  return (
    <Container data-testid={`${dataTestId}-community-switcher`}>
      {showAllTab && (
        <CommunityButton
          onClick={() => onCommunityChange(null)}
          type={!selectedCommunityId ? 'primary' : undefined}
          data-testid={`${dataTestId}-all-tab`}
        >
          All
        </CommunityButton>
      )}
      {[community, ...(filteredCompetitors || [])]
        .filter((item: CommunityType) => Boolean(item?.id))
        .map((item: CommunityType, idx: number) => {
          const isMe = idx === 0;
          const isActive = selectedCommunityId === item.id;
          const testIdSuffix = isMe ? 'me' : `competitor-${idx - 1}`;
          const testId = `${dataTestId}-${testIdSuffix}-tab`;
          return (
            <CommunityButton
              key={item.id}
              onClick={() => onCommunityChange(item.id)}
              type={isActive ? 'primary' : undefined}
              data-testid={testId}
            >
              {item.comunity_name}
              {isMe && ' (Me)'}
            </CommunityButton>
          );
        })}
    </Container>
  );
};

export default CommunitySwitcher;
